// import React from 'react'

// export default function SalesOrders() {
//   return (
//     <div>SalesOrders</div>
//   )
// }


import Content from "../common/Content";
import Footer from "../common/Footer";
import Header from "../common/Header";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import SessionHandler from '../common/SessionHandler';
import $ from 'jquery';

export default function SalesOrders() {
  const [photos, setPhotos] = useState([]);
  const [items, setItems] = useState([]);
  const [mainData, setmainData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(false);
  const [saleDate, setsaleDate] = useState("");


  useEffect(() => {
    // Simulate fetching data
    // const fetchedItems = [
    //   { orderId: 1, name: 'System Architect', location: 'Edinburgh', age: 61, date: '2011-04-25', salary: '$320,800' },
    //   { orderId: 2, name: 'Software Engineer', location: 'San Francisco', age: 29, date: '2012-05-14', salary: '$120,000' },
    //   { orderId: 3, name: 'Designer', location: 'London', age: 42, date: '2013-06-01', salary: '$85,000' }
    // ];
    // setItems(fetchedItems);
    webOrderList();
  }, []);

  useEffect(() => {
    if (items.length > 0) {
        
      const table = $('#example').DataTable({
        destroy: true,
        dom: 'Bfrtip',
        pageLength: 25,
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
        
      });
      
      return () => table.destroy(true);
    }
  }, [items]);




  // useEffect(() => {

  //   $('#example').DataTable({
  //     dom: 'Bfrtip', // This defines the layout for buttons and table
  //     buttons: [
  //       'copy', // Copy to clipboard
  //       'csv', // Export to CSV
  //       'excel', // Export to Excel
  //       'pdf', // Export to PDF
  //       'print' // Print table
  //     ]
  //   });

  //   setItems(fetchedItems);


  //   webOrderList();
  // }, [items]);

  // // useEffect(() => {

  // //   $('#example').DataTable({
  // //     dom: 'Bfrtip', // This defines the layout for buttons and table
  // //     buttons: [
  // //       'copy', // Copy to clipboard
  // //       'csv', // Export to CSV
  // //       'excel', // Export to Excel
  // //       'pdf', // Export to PDF
  // //       'print' // Print table
  // //     ]
  // //   });
  // //   // if (items.length > 0) {
  // //   //  return  API.DataTableScript();
  // //   // }
  // // }, []);


  const webOrderList = () => {
    setPending(true);

    API.getWebOrderData()
      .then((data) => {
        setItems(data);
        console.log(data);
        // const items = datas.ApiDocument.Response.SalesOrders.flatMap(
        //   (SalesOrders) => SalesOrders
        // );
        // const totalRecords = datas.ApiDocument.TotalRecords;
        // //const itemIterate = datas.ApiDocument.Response.Styles.flatMap(mainStyle => mainStyle.StoreDescription);
        // setItems(items);
        // setTotalRecords(totalRecords);
        setPending(false);


      })
      .catch((err) => console.log(err));
  };

  // const usFormattedDate = new Date(isoDateString).toLocaleDateString('en-US');

  const nextButton = document.getElementById("pagination-next-page");

  const handleRowClicked = (row) => {
    // console.log("row", row);
    // console.log("row_id",totalRows);
    setPage(row);
    
  };
// const dataSearch =() =>{
//   alert("Hi");
// }
  // const columns = [
  //   // { name: 'ID', selector: row => row.StyleNo, sortable: true },
  //   {
  //     name: "Order#",
  //     selector: (row) => row.SalesOrderNo,
  //     sortable: true,
  //   },
  //   { name: "Customer", selector: (row) => row.SellInfo.Email, sortable: true },
  //   { name: "Order Date", selector: (row) => row.SalesOrderDateTime, sortable: true },
  //   { name: "Promise Date", selector: (row) => row.PromiseDate, sortable: true },
  //   { name: "Sales Location", selector: (row) => row.SellFromLocation, sortable: true },
  //   { name: "Fill Location", selector: (row) => row.FillLocation, sortable: true },
  //   { name: "Status", selector: (row) => row.StatusName, sortable: true },
  //   { name: "Order Amount", selector: (row) => row.TotalAmountWithTax, sortable: true },
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <a href={`web-orders-view?id=${row.SalesOrderNo}`} value={row.SalesOrderNo}>
  //         Edit
  //       </a>
  //     ),
  //     sortable: true,
  //   },
  //   // {
  //   //   name: "Price",
  //   //   selector: (row) => row.Items[0].BasePrice,
  //   //   sortable: true,
  //   // },
  //   // {
  //   //   name: "Action",
  //   //   cell: (row) => (
  //   //     <a href={`catalog-price-update?id=${row.StyleNo}`} value={row.StyleNo}>
  //   //       Edit
  //   //     </a>
  //   //   ),
  //   //   sortable: true,
  //   // },
  //   // Add more columns as needed
  // ];

  // const RenderData = () => {
    return (
      <>
      
            
            <div class="container-fluid page-body-wrapper">
         


            <div class="main-panel">
        <div class="content-wrapper">
          {/* {pending ? (
            <div className="loader">
              <RotatingLines
                visible={true}
                height="96"
                width="96"
                strokeColor="grey"
                strokeWidth="2"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />{" "}
            </div>
          ) : ( */}
            <div>
            {/* <form class="example" action="/action_page.php"> */}
              {/* <input type="text" placeholder="Search.." name="search2" />
              <button type="submit" onClick={dataSearch}><i class="fa fa-search"></i></button> */}
            {/* </form>  */}

             {/* <DataTable
                title="Web Orders"
                columns={columns}
                data={items}
                pagination
                paginationServer={true}
                // onChangeRowsPerPage={handleRowClicked}
                onChangePage={handleRowClicked}
                paginationTotalRows={totalRecords}
                paginationPerPage={10}
                progressPending={pending}

              /> */}

<div class="Card_contend">
            {pending ? (
              <div className="loader">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeColor="grey"
                  strokeWidth="2"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            ) : (
              <div>
                {!pending ? ( 
                  // <div style={{backgroundColor: "white",padding: "15px",marginTop: "10px"}}>

                  
                  <table id="myTable1" className="row-border">           
                      <thead>
                        {/* <tr>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Order#</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Customer</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Order Date</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Promise Date</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Sales Location</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Fill Location</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Status</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Order Amount</th>
                        </tr> */}
                      </thead>
                        <tbody>
                          {/* {items.map((item, index) => (
                            <tr>
                              <td>{item.SalesOrderNo ? <a href={`web-orders-view?id=${item.SalesOrderNo}`} value={item.SalesOrderNo}>{item.SalesOrderNo}</a> : ''}</td>
                              <td>{item.SellInfo.Email ? item.SellInfo.Email : ''}</td>
                              <td>{item.SalesOrderDateTime ? item.SalesOrderDateTime : ''}</td>
                              <td>{item.PromiseDate ? item.PromiseDate : ''}</td>
                              <td>{item.SellFromLocation ? item.SellFromLocation : ''}</td>
                              <td>{item.FillLocation ? item.FillLocation : ''}</td>
                              <td>{item.StatusName ? item.StatusName : ''}</td>
                              <td>{item.TotalAmountWithTax ? item.TotalAmountWithTax : ''}</td>
                            </tr>
                          ))} */}
                        </tbody>
                      </table>
                // </div>
                ): null} 


    <table id="example" className="table table-striped">
      <thead>
        <tr>
          <th>Parent-No</th>
          <th>Store-No</th>
          <th>Date</th>
          <th>Order Name</th>
          <th>Financial Status</th>
          <th>Fulfillment Status</th>
          <th>Email</th>
          <th>Qty</th>
          <th>Total Price</th>
          {/* <th>Pay Type</th> */}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {items.map(item => (
          <tr key={item.orderId}>
            <td>{item.parentno}</td>
            <td>{item.storenbr}</td>
            <td>{item.created_at}</td>
            <td>#{item.order_name}</td>
            <td>{item.financial_status}</td>
            <td>{item.fulfillment_status}</td>
            <td>{item.email}</td>
            <td>{item.quantity}</td>
            <td>{item.total_price}</td>
            {/* <td>{item.paytype}</td> */}
            <td>View</td>
          </tr>
        ))}
      </tbody>
    </table>







              </div>
            )}
            
            </div>



            </div>
          {/* )} */}
        </div>
      </div>


      </div>  

     
      </>
      
    );
  // };

  // return (
  //   <>
  //     {/* {photos.map((data) => (
  //           <h1>{data.id}</h1>
  //       ))} */}
  //     <Header />
  //     <Content data={RenderData} />
  //     <Footer />
  //   </>
  // );
}
